<template>
  <div>
    <div class="summary">
      <h2 class="title">经营概况</h2>
      <div class="total">
        <!--        数据汇总-->
        <total-summary :year="year" :month="month"/>
      </div>
<!--      <el-divider/>-->
      <div class="totalPayment" style="height: 380px">
        <!--      回款统计-->
        <total-payment-summary :year="year" :month="month"/>
      </div>
<!--      <el-divider/>-->
      <el-row>
        <el-col :lg="12" :md="24">
          <div class="customer">
            <customer-detail-summary :year="year" :month="month"/>
          </div>
        </el-col>
        <el-col :lg="12" :md="24">
          <div class="fboy">
            <KOLAdOrderRank :year="year" :month="month"/>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <!--          销售业绩统计-->
          <SaleSummary :year="year" :month="month" style="width: 100%"/>
        </el-col>
      </el-row>
<!--      <el-divider/>-->
      <el-row style="height: 800px">
        <el-col :lg="12" :md="24">
          <AeSummary :year="year" :month="month"/>
        </el-col>
        <el-col :lg="12" :md="24">
          <PlatformSummary :year="year" :month="month"/>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import TotalSummary from "@/components/summary/myDashboard/TotalSummary";
import { gFunc } from "@/globalFunc";
import TotalPaymentSummary from "@/components/summary/myDashboard/TotalPaymentSummary";
import CustomerDetailSummary from "@/components/summary/myDashboard/CustomerDetailSummary";
import KOLAdOrderRank from "@/components/summary/myDashboard/KOLAdOrderRank";
import SaleSummary from "@/components/summary/myDashboard/SaleSummary";
import AeSummary from "@/components/summary/myDashboard/AeSummary";
import PlatformSummary from "@/components/summary/myDashboard/PlatformSummary";

export default {
  name: '',
  components: {
    PlatformSummary,
    AeSummary,
    SaleSummary,
    KOLAdOrderRank,
    CustomerDetailSummary,
    TotalPaymentSummary,
    TotalSummary,
  },
  data() {
    return {
      year: parseInt(gFunc.parseTime(new Date(), '{y}')),
      month: parseInt(gFunc.parseTime(new Date(), '{m}'))
    }
  },
  methods: {}
}
</script>

<style scoped>
.summary {
  font-size: 14px;
  font-weight: 500;
  color: rgba(50, 50, 50, 1);
}

.title {
  text-align: left;
  padding-left: 20px;
}

</style>
